export function generateEntityId() {
  const bytes = new Uint8Array(5);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function normalizeSensors(sensors = []) {
  return sensors.map((sensor) => ({
    ...sensor,
    sensorID: sensor.sensorID || generateEntityId(),
  }));
}

export function normalizeActionPins(actionPins = []) {
  return actionPins.map((pin) => ({
    ...pin,
    actionPinID: pin.actionPinID || generateEntityId(),
  }));
}

export function getSensorMqttKey(sensor) {
  if (sensor?.sensorID) return sensor.sensorID;
  const type = sensor?.dataType || sensor?.sensorType || 'sensor';
  return `${type}_${sensor?.pin ?? 'unknown'}`;
}

export function getActionPinMqttKey(pin) {
  return pin?.actionPinID || `pin_${pin?.pin ?? 'unknown'}`;
}